module.exports = __webpack_public_path__ + "static/media/LAMI-Guard-Logo.dd6dd099.svg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/LAMI/LAMI-Guard-Logo.svg
// module id = 90
// module chunks = 0